import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDatepickerInputEvent,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { Router } from "@angular/router";
import { arLocale } from "ngx-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
/*import { dateGreaterThan } from "src/app/shared/pipes/dateGreaterThan.directive";*/
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@Component({
  selector: "app-hr-joiners-details",
  templateUrl: "./hr-joiners-details.component.html",
  styleUrls: ["./hr-joiners-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

  ],
})
export class HRJoinersDetailsComponent implements OnInit {
  joinersDataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [
    "EmpCode",
    "NamePerRecords",
    "DesignationName",
    "LocationName",
    "CadreName",
    "DOJ",
    "ProfileSource",
    "RecruiterName",
    "JoiningBonus",
    "JBPayable",
    "SearchFirm",
    "Fee",
    "GMCInclusion",
    "GPAInclusion",
  ];
  allColumns: string[] = [...this.displayedColumns];
  error: string;
  minDate: any;
  currentMonth = "";
  currentFY = "";
  isFreeze = true;
  vendorList = [];
  joinerForm: any;
  @ViewChild("paginatorAll", { static: true }) paginatorAll: MatPaginator;
  @ViewChild("sortAll", { static: true }) sortAll: MatSort;
  @Input() loadJoinerData: any;
  HiddenCol: boolean = true;

  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private formBuilder: FormBuilder
  ) {
    this.joinerForm = this.formBuilder.group({
      joinerDetails: this.formBuilder.array([]),
    });
    this.joinersDataSource = new MatTableDataSource();
  }
  ngOnInit() {
    // this.getVendors();
    //this.getJoiners();
    this.toggleColumns();
  }
  getJoiners() {
    this.joinersDataSource.data = [];
    this._service.getJoinerDetails(this.currentMonth).subscribe(
      (data: any[]) => {

        let validationArray = this.formBuilder.array([]);
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].SearchFirm != "") {
              data[i].SearchFirm = parseInt(data[i].SearchFirm);
            }
            validationArray.push(this.createJoinerFormGroup(data[i]));
          }
          this.joinerForm.setControl("joinerDetails", validationArray);

          // this.joinerForm = this.formBuilder.group({
          //   joinerDetails: this.formBuilder.array(validationArray)
          //  });
          if (this.isFreeze == false) {
            this.isFreeze = data[0].IsFreezed;
          }
          this.joinersDataSource.data = data;
          this.joinersDataSource.paginator = this.paginatorAll;
          this.joinersDataSource.sort = this.sortAll;
          var today = new Date();
          this.minDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        }
      },
      (error) => (this.error = error)
    );
  }
  getVendors() {
    this._service.getVendors().subscribe(
      (data: any[]) => {
        this.vendorList = data;
        this.getJoiners();
      },
      (error) => (this.error = error)
    );
  }
  changed(row) {
    row.IsUpdated = true;
  }
  setDate(event:any):any
  {
    const selectedDate = event.value;
    if (selectedDate) {
        const d = new Date(selectedDate)
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
    }
    return "";
  }
  jBPayableDateChanged(row,event: MatDatepickerInputEvent<Date>) {
        row.JBPayable=this.setDate(event);

  }
  gmcInclusionDateChanged(row,event: MatDatepickerInputEvent<Date>) {
    row.GMCInclusion=this.setDate(event);

}
gpaInclusionDateChanged(row,event: MatDatepickerInputEvent<Date>) {
  row.GPAInclusion=this.setDate(event);

}
  saveJoinerDetails() {

    if (this.joinerForm.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.joinerForm.markAllAsTouched();
      return;
    }

    var result = this.joinersDataSource.data; //.filter(s => s.IsUpdated==true);
    if (result != null && result.length > 0) {
      result[0].LoginUserName = this._userService.getEmail();
      result[0].IsFreezed = this.isFreeze;
      this._service.saveJoinerDetails(result).subscribe(
        (data: any[]) => {
          if (!this.isFreeze) {
            this.toastr.success("Saved Successfully");
          } else {
            this.toastr.success("Freezed Successfully"); 
          }
          this.getJoiners();
        },
        (error) => (this.error = error)
      );
    }
  }

  get feeValidation(): FormArray {
    if (!!this.joinerForm && !!this.joinerForm.controls)
      return this.joinerForm.controls["joinerDetails"] as FormArray;
  }

  private createJoinerFormGroup(item: any): FormGroup {
    return new FormGroup({
    
      // EmpCode: new FormControl(item.EmpCode),
      // NamePerRecords: new FormControl(item.NamePerRecords),
      // DesignationName: new FormControl(item.DesignationName),
      // LocationName: new FormControl(item.LocationName),
      // CadreName: new FormControl(item.CadreName),
      // DOJ: new FormControl(item.DOJ),
      // ProfileSource: new FormControl(item.ProfileSource),
      // RecruiterName: new FormControl(item.RecruiterName),
      // JoiningBonus: new FormControl(item.JoiningBonus),
      // JBPayable: new FormControl(item.JBPayable),
      // SearchFirm: new FormControl(item.SearchFirm),
      Fee: new FormControl(  { value: item.Fee, disabled: this.isFreeze }, [Validators.pattern(/^(?!0(\.0+$)?$)(0|[1-9]\d{0,11})(\.\d{1,2})?$/)]),
      // GMCInclusion: new FormControl(item.GMCInclusion),
      // GPAInclusion: new FormControl(item.GPAInclusion),
      // comment: new FormControl(item.comment, [Validators.required])
    });
  }

  toggleColumns(): void {
    this.HiddenCol = !this.HiddenCol; 
    if (this.HiddenCol) {
      this.displayedColumns = [...this.allColumns];
    } else {
      this.displayedColumns = this.allColumns.slice(0, this.allColumns.length - 8);
    }
  }

}
